import client from '../client';
import uuid from 'uuid';
import uploadVideoToS3 from '../common/utils/uploadVideoToS3';

export const ADD_COURSE = 'ADD_COURSE';
export const ADD_VIDEO_TO_COURSE = 'ADD_VIDEO_TO_COURSE';
export const DELETE_COURSE = 'DELETE_COURSE';
export const EDIT_COURSE = 'EDIT_COURSE';
export const EDITING_QUIZ = 'EDITING_QUIZ';
export const FETCH_COURSES = 'FETCH_COURSES';
export const FETCH_PUBLIC_COURSES = 'FETCH_PUBLIC_COURSES';
export const GET_COURSE_VIDEO = 'GET_COURSE_VIDEO';
export const UPLOAD_COURSE_VIDEO = 'UPLOAD_COURSE_VIDEO';
export const UPLOAD_COURSE_VIDEO_PROGRESS = 'UPLOAD_COURSE_VIDEO_PROGRESS';
export const GET_UNASSIGNED_BADGES = 'GET_UNASSIGNED_BADGES';
export const GET_QUIZ = 'GET_QUIZ';
export const CREATE_QUIZ = 'CREATE_QUIZ';
export const UPDATE_QUIZ = 'UPDATE_QUIZ';
export const DELETE_QUIZ = 'DELETE_QUIZ';
export const GET_DAILY_EXTRA = 'GET_DAILY_EXTRA';
export const CREATE_DAILY_EXTRA = 'CREATE_DAILY_EXTRA';
export const UPDATE_DAILY_EXTRA = 'UPDATE_DAILY_EXTRA';
export const DELETE_DAILY_EXTRA = 'DELETE_DAILY_EXTRA';
export const GET_LIBRARY_VIDEO_INFO_BY_CATEGORY = 'GET_LIBRARY_VIDEO_INFO_BY_CATEGORY';

export function addCourse(values) {
  return {
    type: ADD_COURSE,
    promise: client.post('courses', values),
  };
}

export function deleteCourse(id) {
  return {
    type: DELETE_COURSE,
    promise: client.delete(`courses/${id}`),
    id,
  };
}

export function editCourse(id, values) {
  const data = new FormData();
  if (values.image_id) data.append('image_id', values.image_id);
  if (values.icon_id) data.append('icon_id', values.icon_id);
  if (values.image) data.append('image', values.image, uuid.v4());
  if (values.icon) data.append('icon', values.icon, uuid.v4());
  if (values.badge_id) data.append('badge_id', values.badge_id);
  data.append('name', values.name);
  data.append('description', values.description);
  data.append('long_description', values.long_description);
  data.append('published', values.published);
  data.append('price', values.price);

  return {
    type: EDIT_COURSE,
    promise: client.put(`courses/${id}`, data),
  };
}

export function fetchCourses() {
  return {
    type: FETCH_COURSES,
    promise: client.get('courses/all'),
  };
}

export function addPreviewVideoToCourse(courseId, key) {
  return {
    type: ADD_VIDEO_TO_COURSE,
    promise: client.post(`courses/${courseId}/video`, { key }),
  };
}

export function getCoursePreviewVideo(courseId) {
  return {
    courseId,
    type: GET_COURSE_VIDEO,
    promise: client.get(`courses/${courseId}/video`, null, {
      credentials: 'include', // Required for browser to respect Set-Cookie headers
    }),
  };
}

export function updateUploading(uploading) {
  return {
    type: UPLOAD_COURSE_VIDEO,
    uploading,
  };
}

export function updateUploadProgress(loaded, total) {
  return {
    type: UPLOAD_COURSE_VIDEO_PROGRESS,
    loaded,
    total,
  };
}

export function getQuiz(id) {
  return {
    promise: client.get(`quizzes/${id}`),
    type: GET_QUIZ,
  };
}

export function createQuiz(lessonId, quiz) {
  return {
    promise: client.post(`quizzes`, { lesson_id: lessonId, ...quiz }),
    type: CREATE_QUIZ,
    lessonId,
  };
}

export function updateQuiz(id, quiz) {
  return {
    promise: client.put(`quizzes/${id}`, quiz),
    type: UPDATE_QUIZ,
  };
}

export function deleteQuiz(id, lessonId) {
  return dispatch => {
    return dispatch({
      promise: client.delete(`quizzes/${id}`),
      type: DELETE_QUIZ,
      lessonId,
    }).then(() => {
      dispatch({ type: `${GET_QUIZ}_RESET` });
    });
  };
}

export function editingQuiz(editing) {
  return {
    type: EDITING_QUIZ,
    editing,
  };
}

export function getDailyExtra(id) {
  return {
    promise: client.get(`daily-extras/${id}`),
    type: GET_DAILY_EXTRA,
  };
}

function convertDailyExtraToFormData(dailyExtra) {
  const data = new FormData();
  if (dailyExtra.image_id) data.append('image_id', dailyExtra.image_id);
  if (dailyExtra.image) data.append('image', dailyExtra.image, uuid.v4());
  if (dailyExtra.library_video_id) data.append('library_video_id', dailyExtra.library_video_id);
  data.append('body_text', dailyExtra.body_text);
  data.append('button_link', dailyExtra.button_link);
  data.append('button_new_window', dailyExtra.button_new_window);
  data.append('button_text', dailyExtra.button_text);
  data.append('header', dailyExtra.header);
  data.append('name', dailyExtra.name);
  return data;
}

export function createDailyExtra(lessonId, dailyExtra) {
  const data = convertDailyExtraToFormData(dailyExtra);
  data.append('lessonId', lessonId);

  return {
    lessonId,
    promise: client.post(`daily-extras`, data),
    type: CREATE_DAILY_EXTRA,
  };
}

export function updateDailyExtra(id, dailyExtra) {
  const data = convertDailyExtraToFormData(dailyExtra);

  return {
    type: UPDATE_DAILY_EXTRA,
    promise: client.put(`daily-extras/${id}`, data),
  };
}

export function deleteDailyExtra(id, lessonId) {
  return dispatch => {
    return dispatch({
      promise: client.delete(`daily-extras/${id}`),
      type: DELETE_DAILY_EXTRA,
      lessonId,
    }).then(() => {
      dispatch({ type: `${GET_DAILY_EXTRA}_RESET` });
    });
  };
}

export function uploadVideo(courseId, file) {
  return dispatch => {
    dispatch(updateUploading(true));

    return uploadVideoToS3(dispatch, file, updateUploadProgress)
      .then(data => dispatch(addPreviewVideoToCourse(courseId, data.Key)))
      .then(() => dispatch(getCoursePreviewVideo(courseId)))
      .then(() => {
        dispatch(updateUploading(false));
        dispatch(updateUploadProgress(0, 100));
      });
  };
}

export function getUnassignedBadges() {
  return {
    promise: client.get('badges/unassigned'),
    type: GET_UNASSIGNED_BADGES,
  };
}

export function getLibraryVideoInfoByCategory(categoryId) {
  return {
    type: GET_LIBRARY_VIDEO_INFO_BY_CATEGORY,
    promise: client.get(`library/categories/${categoryId}/video-info`),
  };
}



// WEBPACK FOOTER //
// ./src/courses/actions.js